import { z } from "zod";

export const EnterpriseContactUsSchema = z.object({
  email: z.string().email(),
  name: z.string(),
  company: z.string(),
  message: z.string(),
});

export type EnterpriseContactUs = z.infer<typeof EnterpriseContactUsSchema>;
